import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

type NavigationButtonType = {
  label: string;
  link: string;
};

const NavigationButton: React.FC<NavigationButtonType> = ({ label, link }) => {
  return (
    <Box>
      <Button
        variant="contained"
        color="inherit"
        component={Link}
        to={link}
        sx={(theme) => ({
          backgroundColor: theme.palette.navigationButtonColor.main,
          color: "white",
          boxShadow: 1,
          height: "30px", // Augmentez pour une meilleure lisibilité
          minWidth: "130px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
          lineHeight: 1,
          "&:hover": {
            backgroundColor: theme.palette.navigationButtonColor.main,
            opacity: "0.95",
            transition: "0.6s",
          },
        })}
      >
        <Typography sx={{ fontSize: "14px", paddingTop: "3px" }}>
          {label}
        </Typography>
      </Button>
    </Box>
  );
};

export { NavigationButton };
